import { useCallback, useState } from 'react';
import { LuciusLogo } from '../Custom/Logo/LuciusLogo';
import { LogoIcon } from '../SvgIcons/LogoIcon';
import { twMerge } from 'tailwind-merge';

export const SideBarHeader = () => {
  const [collapsed, setCollapsed] = useState(false);

  const handleToggle = useCallback(() => {
    document.body.classList.toggle('sidebar-collapse');
    setCollapsed((prev) => !prev);

    const sidebar = document.querySelector('#sidebar');
    if (sidebar) {
      sidebar.classList.add('animating');
      sidebar.addEventListener(
        'transitionend',
        () => sidebar.classList.remove('animating'),
        { once: true },
      );
    }
  }, []);

  return (
    <div
      className="sidebar-header flex items-center relative justify-between px-3 lg:px-6 shrink-0 max-lg:mt-7"
      id="sidebar_header"
    >
      <div>
        <LuciusLogo
          containerClassName="default-logo"
          logoIconClassName="dark-mode:[&>path:nth-child(2)]:fill-white dark-mode:[&>g[clip-path]>path:nth-child(2)]:fill-white"
        />
        <LogoIcon
          className="small-logo w-[32.85px] h-auto dark-mode:[&>path:nth-child(2)]:fill-white max-lg:hidden"
          circleGradientId="paint0_linear_small_logo"
        />
      </div>
      <button
        className="btn btn-icon btn-icon-md size-[30px] rounded-lg border border-gray-200 bg-white shadow-xl text-gray-500 hover:text-gray-700 toggle absolute left-full top-2/4 -translate-x-2/4 -translate-y-2/4 dark-mode:bg-coal-600 dark-mode:border-slate-600 max-lg:hidden"
        id="sidebar_toggle"
        onClick={handleToggle}
      >
        <i
          className={twMerge(
            'ki-filled ki-left text-gray-99A1B6 transition-all duration-300',
            collapsed && 'rotate-180',
          )}
        ></i>
      </button>
    </div>
  );
};
